export default __webpack_public_path__ + "static/media/goal_tracking.3547e9c1.png";